import { render, staticRenderFns } from "./IcoPeople.vue?vue&type=template&id=58f7c1bd&lang=html"
import script from "./IcoPeople.vue?vue&type=script&lang=js"
export * from "./IcoPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports